<template>
  <kst-page-edit autoValidate
    @init="handleInit"
    @submit="handleSubmit"
  >
    <Details
      :deliveryData="deliveryData"
      :userData="userData"
    />
    <Delivery :deliveryData="deliveryData"/>
  </kst-page-edit>
</template>

<script>
import InputPageMixin from "../../../mixins/InputPageMixin.js";
import Model from "../DlvModel.js";
import Services from "../../../services/Api/DeliveryServices.js";

import Delivery from "./DlvES_Delivery.vue";
import Details from "./DlvES_Details.vue";

export default {
  mixins: [InputPageMixin],
  components: {
    Delivery,
    Details
  },
  data: () => ({
    deliveryData: {},
    userData: {}
  }),
  methods: {
    /*** by page ***/

    handleInit(id, loadEdit) {
      this.resetData();

      const config = Services.getEditStatusData(id);
      loadEdit(config, this.handleInit_Success);
    },
    handleInit_Success(data) {
      this.deliveryData = data.Details;
      Model.setDetailsByStatus(this.deliveryData);
      for (const item of this.deliveryData.Items) {
        Model.updateItem(item);
      }

      Model.EditStatus.setDetailsByData(this.userData, this.deliveryData);
      Model.setDetailsByStatus(this.userData);
    },

    handleSubmit(saveData) {
      let data = Model.EditStatus.populateData(this.userData);
      const config = Services.putStatus(data);
      saveData(config, this.handleSubmit_Success);
    },
    handleSubmit_Success() {
      this.disableRouteLeave();
    },

    /*** custom ***/

    resetData() {
      this.deliveryData = {};
      this.userData = Model.createDetails();
    }
  }
}
</script>